import PlansEditorContainer from './containers/PlansEditorContainer';

export default PlansEditorContainer;
